import {parallel} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {SpinUIAct} from '@gongxigames/framework/slotV2/ui/acts/SpinUIAct';
import {UIState} from '@gongxigames/framework/slotV2/baseClasses/uiState/UIState';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {JurisdictionZoneUpdateSessionBetUIAct} from '@gongxigames/framework/slotV2/ui/acts/JurisdictionZoneUpdateSessionBetUIAct';

export class SpinUIState extends UIState {
    public static readonly ID = 'SpinUIState';

    public setAct(): void {
        this.act = parallel([
            JurisdictionZoneUpdateSessionBetUIAct,
            SpinUIAct
        ]);
    }

    canExecute(): boolean {
        return slotStore.feature_type.value?.type === 'spin';
    }
}